import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, getHousekeepingApplicationMasterListUrl, insertUpdateHousekeepingApplicationMasterUrl, deleteHousekeepingApplicationMasterUrl, insertUpdateMasterHousekeepingUrl, getMasterHousekeepingUrl, GET_HOUSEKEEPING_APPLICATION_MASTER_LIST, INSERT_UPDATE_HOUSEKEEPING_APPLICATION_MASTER, DELETE_HOUSEKEEPING_APPLICATION_MASTER, INSERT_UPDATE_MASTER_HOUSEKEEPING, GET_MASTER_HOUSEKEEPING } from "../../../../utils/constants";


export const insertUpdateHousekeepingApplicationMaster_action = (HousekeepingApplicationList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            HousekeepingApplicationList: HousekeepingApplicationList
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertUpdateHousekeepingApplicationMasterUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_HOUSEKEEPING_APPLICATION_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getHousekeepingApplicationMasterList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getHousekeepingApplicationMasterListUrl, params, headers)

        dispatch({
            type: GET_HOUSEKEEPING_APPLICATION_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getMasterHousekeeping_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getMasterHousekeeping_action------->", params)

        const res = await axiosGet(getMasterHousekeepingUrl, params, headers)

        dispatch({
            type: GET_MASTER_HOUSEKEEPING,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateMasterHousekeeping_action = (rateList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            HousekeepingId: 0,
            rateList: rateList
        }
        console.log("insertUpdateMasterHousekeeping_action------->", params)

        const res = await axiosPost(insertUpdateMasterHousekeepingUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_MASTER_HOUSEKEEPING,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteHousekeepingApplicationMaster_action = (HousekeepingContactPersonID, HousekeepingBankDetailID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            HousekeepingContactPersonID: HousekeepingContactPersonID,
            HousekeepingBankDetailID: HousekeepingBankDetailID
        }
        console.log("deleteExhibitionDocument_action Action------->", params)

        const res = await axiosGet(deleteHousekeepingApplicationMasterUrl, params, headers)

        dispatch({
            type: DELETE_HOUSEKEEPING_APPLICATION_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}